import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, CircularProgress } from '@material-ui/core';
import { createStyles, Theme, WithStyles, withStyles } from '@material-ui/core/styles';

interface IProps extends WithStyles<typeof styles> {
  length: number;
  loading: boolean;
  onLoadMore: () => void;
}

const styles = (theme: Theme) =>
  createStyles({
    button: {
      display: 'inline-block',
      padding: 0,
      marginBottom: theme.spacing(1),
    },
    progress: {
      marginLeft: theme.spacing(1),
    },
  });

const LoadMore: FC<IProps> = ({ classes, loading, onLoadMore, length }) => {
  const { t } = useTranslation();

  return (
    <Button disabled={loading} onClick={onLoadMore} className={classes.button}>
      {t('content:xMoreComment', { count: length })}
      {loading && <CircularProgress color="inherit" className={classes.progress} size={10} />}
    </Button>
  );
};

export default withStyles(styles)(LoadMore);
